module.exports = __webpack_public_path__ + "img/summary_adspend.b9de8df.svg";